import actions from "@/store/modules/company/actions";
import mutations from "@/store/modules/company/mutations";
import state from "@/store/modules/company/state";

export default {
    actions,
    mutations,
    state
}